import React from "react";
// import { Link } from "react-router-dom";
import "./FreeLegalAdviceCSS.css";
import FAQsBox from "./FAQsBox";
import LegalBradcrumeSection from "./LegalBradcrumeSection";
import { Link } from "react-router-dom";
import TalktoLawyerForm from "./TalktoLawyerForm";

export default function FreelegalAdvicePhone() {
  return (
    <>
      <LegalBradcrumeSection
        Pagename={"Talk to a Lawyer"}
        page1={[{ name: "Talk to a Lawyer" }]}
      />

      <section
        className={`legal_section section_padding_top section_padding_bottom `}
        style={{ background: " #f5f7fc82" }}
      >
        <div className="auto-container">
          <div className="row wow fadeInUp">
            <div className="col-lg-8 col-md-12">
              <div className="formdesedataBOX">
                <h4 className="formdescheading">Talk to a Lawyer</h4>
                <p className="formdescPera">
                  Just fill in your details to immediately get the best matched
                  lawyers for legal issues. Every lawyer profile has been
                  verified, and you can contact them within minutes.
                </p>
                <div className="formdesctitlebox">
                  <div className="formDatarow">
                    <TalktoLawyerForm />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="formdesedataBOX">
                <h4 className="formdescheading">
                  <img
                    src="../images/Icons-16.svg"
                    className="headingsiteimg"
                    alt="no"
                  />
                  What are others saying?
                </h4>
                <p className="formdescPera">
                  “I got clear answers to my legal problem from top lawyers
                  within a few minutes of posting a question at LawRato. It
                  works like magic"
                </p>
                <div className="formdesctitlebox">
                  <div className="formDatarow">
                    <h6>- Anuradha S</h6>
                  </div>
                </div>
              </div>

              <div className="formdesedataBOX">
                <h4 className="formdescheading">
                  <img
                    src="../images/Icons-18.svg"
                    className="headingsiteimg"
                    alt="no"
                  />
                  Talk to a top rated lawyer
                </h4>
                <p className="formdescPera">
                  Contact a top rated lawyer in your city to get detailed
                  opinion on your legal problem.
                </p>

                <div className="formdesctitlebox">
                  <div className="formDatarow">
                    <Link className="sencondBTNhover mb-3">
                      Talk to a Lawyer
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row wow fadeInUp">
            <div className="col-lg-12 col-md-12">
              <div className="formdesedataBOX">
                <h4 className="formdescheading">
                  Get Legal Advice Over the Phone
                </h4>
                <p className="formdescPera">
                  Going through a divorce? Launching a business? Hurt in a car
                  accident? Writing a will? Facing a lawsuit? In any of these
                  situations, you may consider hiring a lawyer to advise you or
                  represent your interests. While each state has many lawyers to
                  choose from, choosing the right lawyer can make the difference
                  between a pleasant and a frustrating experience. The phone
                  advice received from legal experts can make one understand the
                  intricacies involved in a particular case and can help the
                  party understand his or her legal journey.
                </p>
                <p className="formdescPera">
                  It's important to understand that a good lawyer doesn't
                  guarantee that you'll win your case. However, having a good
                  lawyer will give you the best chances for a favorable outcome
                  and the comfort of knowing that you had the best legal
                  representation. The first step in hiring a lawyer is choosing
                  one in the practice area that is related to your legal matter
                  because this will ensure that the lawyer is well versed in
                  cases similar to yours.
                </p>
                <p className="formdescPera">
                  lawrato.com makes it easier for you to get legal advice from
                  Top Rated Lawyers across the country. Discuss your legal issue
                  over phone, email, schedule an office meeting, or consult with
                  any of the listed Lawyers at your home / office. We are ready
                  to help you, as per your convenience.
                </p>
                {/* <div className="formdesctitlebox">
                  <div className="formDatarow">
                   
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div className="row wow fadeInUp">
            <div className="col-lg-12 col-md-12">
              <div className="formdesedataBOX">
                <h4 className="formdescheading">Frequently Asked Questions</h4>
                <div className="formdesctitlebox pb-4">
                  <div className="formDatarow">
                    <FAQsBox />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
